// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/Initial/BLogo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.secondMobPageBdy{
    width: 100vw;
    width: 100svw;
    height: 100vh;
    height: 100svh;
    max-width: 100vw;
    max-width: 100svw;
    max-height: 100vh;
    max-height: 100svh;
    overflow-x: hidden;
}
.secondMobPage{
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center/cover;
    background-position: 100%;
    background-color: var(--white-color);
    font-family: "Poppins", sans-serif;
    font-weight: 700;
}


.secondMobPage .containerLogoBabita{
    margin: 35px 0 20px 0;
}

.secondMobPage .titleQuest {
    font-size: 1.5em;
    text-align: center;
}


.secondMobPage .enterOptions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 60vh;
}


.secondMobPage .enterOptions .option {
    width: 70%;
    background-color: var(--blackMain-color);
    border-radius: 5px;
    padding: 10px 10px;
    font-size: 1.4em;
    margin: 10px 0;
    text-align: center;
    color: var(--white-color);
}`, "",{"version":3,"sources":["webpack://./src/assets/css/secondMobPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,0EAAmE;IACnE,yBAAyB;IACzB,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;AACpB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,wCAAwC;IACxC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B","sourcesContent":[".secondMobPageBdy{\r\n    width: 100vw;\r\n    width: 100svw;\r\n    height: 100vh;\r\n    height: 100svh;\r\n    max-width: 100vw;\r\n    max-width: 100svw;\r\n    max-height: 100vh;\r\n    max-height: 100svh;\r\n    overflow-x: hidden;\r\n}\r\n.secondMobPage{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    min-height: 100vh;\r\n    background: url('../imgs/Initial/BLogo.png') no-repeat center/cover;\r\n    background-position: 100%;\r\n    background-color: var(--white-color);\r\n    font-family: \"Poppins\", sans-serif;\r\n    font-weight: 700;\r\n}\r\n\r\n\r\n.secondMobPage .containerLogoBabita{\r\n    margin: 35px 0 20px 0;\r\n}\r\n\r\n.secondMobPage .titleQuest {\r\n    font-size: 1.5em;\r\n    text-align: center;\r\n}\r\n\r\n\r\n.secondMobPage .enterOptions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 60vh;\r\n}\r\n\r\n\r\n.secondMobPage .enterOptions .option {\r\n    width: 70%;\r\n    background-color: var(--blackMain-color);\r\n    border-radius: 5px;\r\n    padding: 10px 10px;\r\n    font-size: 1.4em;\r\n    margin: 10px 0;\r\n    text-align: center;\r\n    color: var(--white-color);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
